export default {
    state: {
        iframeUrl: [],   // current nested page routing path
        iframeUrls: []   // All nested page routing path access URLs
    },
    getters: {
    },
    mutations: {
        setIFrameUrl(state, iframeUrl){  //  set iframeUrl
            state.iframeUrl = iframeUrl
        },
        addIFrameUrl(state, iframeUrl){  // iframeUrls
            state.iframeUrls.push(iframeUrl)
        }
    },
    actions: {
    }
}